import { render, staticRenderFns } from "./BedsideAnamneseDialog.vue?vue&type=template&id=3367b610&scoped=true"
import script from "./BedsideAnamneseDialog.vue?vue&type=script&lang=js"
export * from "./BedsideAnamneseDialog.vue?vue&type=script&lang=js"
import style0 from "./BedsideAnamneseDialog.vue?vue&type=style&index=0&id=3367b610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3367b610",
  null
  
)

export default component.exports